<template lang="pug">
transition(name="slide-fade")
  .guest-mail(v-show='isModalShow')
    i.guest-mail-close.icon-remove-sign(@click="closeGuestMail")
    .guest-mail-inner
      h2.h3.u-mbs Be the first to hear about deals!
      p.u-mbm Sign up for TOM Shop emails to get info about new figures, special sales, and more.
      form(action="#", method="post", @submit.prevent="submit", :class='{ "c-loading": isLoading }')
        .c-message.c-message--success(v-if="isSubscribed")
          .c-message__icon
            i.icon-ok
          .c-message__body Registration completed
        .form-ctl__error(v-if="errorMessage || errors.has('email')", v-text="errorMessage || errors.first('email')")
        .form__item.form__group
          input.form-ctl(type="text", name="email", v-model="email", :class='{ "error": errorMessage || errors.first("email") }', v-validate="'required|email'")
          input.c-btn.c-btn--primary(type="submit", value="Submit", :disabled="errors.first('email')")

      small
        | By signing up, you agree to the terms of our
        a(href="https://otakumode.com/privacy" target="_blank") Privacy Policy.
</template>

<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate';

import axios from '../../api/common/axios';
import Cookies from 'js-cookie';

Vue.use(VeeValidate, {
  classes: true,
  classNames: {
    valid: 'is-valid',
    invalid: 'is-invalid'
  }
});

export default {
  data() {
    return {
      isLoading: false,
      isModalShow: false,
      isSubscribed: false,
      guestMailModalOpen: true,
      email: '',
      errorMessage: ''
    };
  },
  mounted() {
    if (
      Cookies.get('guestMailMagazineSubscribed') ||
      Cookies.get('closeGuestMailMagazine') ||
      window.tom.conf.isLogin
    ) {
      this.guestMailModalOpen = false;
    }

    if (this.guestMailModalOpen) {
      setTimeout(() => {
        this.isModalShow = true;
      }, 8000);
    }
  },
  methods: {
    closeGuestMail() {
      this.isModalShow = false;
      Cookies.set('closeGuestMailMagazine', true, {
        path: '/'
      });
    },
    submit() {
      this.isLoading = true;
      this.errorMessage = '';

      const data = {
        email: this.email
      };

      axios
        .post('/api/mailmagazines/subscribe', data)
        .then((response) => {
          this.isLoading = false;
          this.isSubscribed = true;
          if (response.data.status === 'ng') {
            this.errorMessage =
              (response.data.errors && response.data.errors.general) ||
              'An error occurred. Please wait a moment before trying again.';
            return;
          }
          Cookies.set('guestMailMagazineSubscribed', true, {
            path: '/',
            expires: 365
          });
          window.tom.helper.ga.push([
            'event',
            'GuestMailMagazine',
            'Subscribed',
            window.encodeURIComponent(window.location.href),
            1
          ]);
          setTimeout(() => {
            this.isModalShow = false;
          }, 3000);
        })
        .catch((err) => {
          this.isLoading = false;
          this.errorMessage =
            err.msg ||
            'An error occurred. Please wait a moment before trying again.';
        });
    }
  }
};
</script>

<style scoped>
.guest-mail {
  position: fixed;
  bottom: 0px;
  left: 0;
  width: 100%;
  padding: 50px 20px;
  background: rgb(255, 255, 255);
  box-shadow: rgba(0, 0, 0, 0.16) 0px -2px 12px;
  z-index: 998;
}

.guest-mail-close {
  font-size: 2rem;
  position: absolute;
  top: 12px;
  right: 16px;
  cursor: pointer;
}

.guest-mail-inner {
  width: 100%;
  max-width: 638px;
  margin: 0px auto;
}

.form__group {
  display: flex;
  border: 2px solid #d0d0d0;
}

.form__group .form-ctl {
  height: auto;
  border: none;
}

.form__group .c-btn {
  min-width: 140px;
  border-radius: 0 1px 1px 0;
}

.slide-fade-enter-active {
  transition: all 0.25s ease;
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(300px);
}
</style>
